import Http from "./http-service";

import { PRIVATE_API_ROUTES } from "../constants";
import { showNotification } from "../UtilityFunctions/notification";
import { getLocalizedMessage } from "../UtilityFunctions/utils";
import {
  EMAIL_UNIQUE,
  EMPLOYEE_ID_UNIQUE,
  GLOBAL_ID_UNIQUE,
  OTHER_EMAIL_UNIQUE,
  REQUIRED_PRODUCT_CATEGORY,
} from "../constants/errorConstants";
import { getUserById as getUserByIdAction } from "../globalContext/Users/userActions";
import { setLoading } from "../globalContext/globalLoader/globalLoaderAction";

class UserManagementService {
  static getRoles() {
    return Http.get(PRIVATE_API_ROUTES.ALL_ROLES).then((res) => {
      return res?.data?.data;
    });
  }

  static getSubProductCategoryBasedOnCountry({
    loaderDispatch,
    queryParams,
    intl,
  }) {
    loaderDispatch(setLoading(true));
    return Http.get(PRIVATE_API_ROUTES.PRODUCT_CATEGORY, queryParams)
      .then((res) => {
        loaderDispatch(setLoading(false));
        return res?.data?.data;
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }

  static getUserDataById({
    loaderDispatch,
    dispatch,
    userId,
    intl,
    queryParams,
  }) {
    loaderDispatch(setLoading(true));
    return Http.get(PRIVATE_API_ROUTES.USER_BY_ID(userId), queryParams)
      .then((res) => {
        if (dispatch) {
          loaderDispatch(setLoading(false));
          dispatch(getUserByIdAction(res?.data?.data));
        } else {
          loaderDispatch(setLoading(false));
          return Promise.resolve(res?.data?.data);
        }
      })
      .catch((error) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(error);
      });
  }

  static addUser(loaderDispatch, body, navigate, intl, resetForm) {
    loaderDispatch(setLoading(true));
    return Http.post(PRIVATE_API_ROUTES.CREATE_USER, body)
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "userManagement.addedUser")
        );
        navigate("/users");
        resetForm();
        return Promise.resolve(res);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        if (err?.response?.data?.code === EMAIL_UNIQUE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserEmailUnique")
          );
        } else if (err?.response?.data?.code === EMPLOYEE_ID_UNIQUE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserEmployeeIdUnique")
          );
        } else if (err?.response?.data?.code === GLOBAL_ID_UNIQUE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserGlobalIdUnique")
          );
        } else if (err?.response?.data?.code === OTHER_EMAIL_UNIQUE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserOtherEmailUnique")
          );
        } else if (err?.response?.data?.code === REQUIRED_PRODUCT_CATEGORY) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserRequiredProducts")
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
        return Promise.reject(err);
      });
  }

  static editUser({ loaderDispatch, body, navigate, intl, resetForm, userId }) {
    loaderDispatch(setLoading(true));
    return Http.put(`${PRIVATE_API_ROUTES.CREATE_USER}/${userId}`, body)
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "userManagement.editedUser")
        );
        return Promise.resolve(res);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        if (err?.response?.data?.code === EMAIL_UNIQUE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserEmailUnique")
          );
        } else if (err?.response?.data?.code === EMPLOYEE_ID_UNIQUE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserEmployeeIdUnique")
          );
        } else if (err?.response?.data?.code === GLOBAL_ID_UNIQUE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserGlobalIdUnique")
          );
        } else if (err?.response?.data?.code === OTHER_EMAIL_UNIQUE) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.addUserOtherEmailUnique")
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
        return Promise.reject(err);
      });
  }
}

export default UserManagementService;
